import React from 'react';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';
import Button from 'gatsby-theme-core/src/components/button';

const Links = ({ className }) => {
  const { pages } = useStaticQuery(graphql`
    query ACMStrapi4SubFooterLinks {
      pages: allStrapiPage(
        filter: {
          template: {
            in: ["disclaimer", "privacy_policy", "terms_and_conditions"]
          }
        }
      ) {
        nodes {
          id
          slug
          title
        }
      }
    }
  `);
  return (
    <>
      {pages.nodes.map(({ id, slug, title }) => (
        <Item className={className} key={id}>
          <StyledButton to={slug}>
            {title}
          </StyledButton>
        </Item>
      ))}
      <Item className={className}>
        <StyledButton href="https://www.automotivated.nl/">
          Website powered by Automotivated
        </StyledButton>
      </Item>
    </>
  );
};

const Item = styled.span`
  &:not(:last-child) {
    &:after {
      padding: 0 .25rem;
      content: var(--footer-link-after-content);
      color: var(--footer-link-color);
    }
  }
`;

const StyledButton = styled(Button).attrs({ link: true })`
  color: var(--footer-link-color);
  text-decoration: none;
  font-size: 0.875rem;
  transition: .2s;
  line-height: ${({ theme }) => theme.baseLineHeight};
  &:hover {
    color: var(--footer-link-hover-color);
  }
`;

export default styled(Links)`
  --footer-link-color: ${({ theme }) => theme.grayLightColor};
  --footer-link-hover-color: ${({ theme }) => theme.primaryColor};
  --footer-link-after-content: '|';
`;
